import Dialog from 'ui/organisms/dialogs/Dialog/Dialog';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';
import FormField from 'ui/molecules/FormField/FormField';
import InputText from 'ui/atoms/InputText/InputText';

const DialogAddVideolesson = ({ t, open, onClose, onSuccess }) => {
  const [videolessonLink, setVideolessonLink] = useState('');
  const [error, setError] = useState(null);
  function isValidYouTubeUrl(url) {
    let patron = /^(http(s)?:\/\/)?((w){3}.)?youtu(be|.be)?(\.com)?\/.+$/;
    return patron.test(url);
  }

  function onAddLink(e) {
    e.preventDefault();
    if (isValidYouTubeUrl(videolessonLink)) {
      onSuccess(videolessonLink);
      onClose();
      setVideolessonLink('');
      setError(null);
    } else {
      setError(t('videolessons:Invalid video URL'));
    }
  }

  return (
    <Dialog
      isOpen={open}
      className={'dialog-add-videolesson'}
      buttonTextSuccess={t('actions:Add')}
      buttonTextCancel={t('actions:Cancel')}
      title={t('videolessons:New videolesson')}
      onSuccess={onAddLink}
      onCancel={onClose}
      onClose={onClose}
      isDisabledSuccess={videolessonLink.length < 3}
    >
      <div className="dialog-add-videolesson__content">
        <form onSubmit={onAddLink}>
          <FormField
            error={!!error}
            errorMessage={error}
            label={t('videolessons:Paste video url here')}
          >
            <InputText
              placeholder={t('videolessons:https')}
              value={videolessonLink}
              onChange={(e) => {
                setError(null);
                setVideolessonLink(e.currentTarget.value);
              }}
            />
          </FormField>
        </form>
      </div>
    </Dialog>
  );
};

DialogAddVideolesson.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
  name: PropTypes.string,
};

DialogAddVideolesson.defaultProps = {
  onClose: function () {},
  open: false,
};

export default withTranslation(['actions', 'content', 'placeholder'])(DialogAddVideolesson);
